export default __webpack_public_path__ + "static/PMG_EGTB_MYRUMAH_PDS_AGENCY_BM-7c7ce2800f884a6d9c7819a7add82923.pdf";